/** Configuration — Validation — modules, scope, base checks, conditions, sample rules */

export const VALIDATION_ROUTE = '/admin/configuration/validation';
export const UNAVAILABLE_MESSAGE = 'We could not complete the required check. Please try again.';

export const VAL_MODULE_OPTIONS = [
  { value: 'account_access', label: 'Account Access' },
  { value: 'customers', label: 'Customer' },
  { value: 'businesses', label: 'Business' },
  { value: 'passwords', label: 'Passwords' },
  { value: 'posts', label: 'Posts' },
  { value: 'quotes', label: 'Quotes' },
  { value: 'messages', label: 'Messages' },
  { value: 'reviews', label: 'Reviews' },
  { value: 'flagging', label: 'Flagging' },
  { value: 'support_tickets', label: 'Support Tickets' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'teams_permissions', label: 'Teams & Permissions' },
];

export const VAL_TRIGGER_OPTIONS = [
  { value: 'submit', label: 'Submit' },
  { value: 'save', label: 'Save' },
  { value: 'send', label: 'Send' },
  { value: 'publish', label: 'Publish' },
];

export const VAL_BASE_CHECK_OPTIONS = [
  { value: 'text', label: 'Text' },
  { value: 'email_address', label: 'Email Address' },
  { value: 'web_address', label: 'Web Address' },
  { value: 'phone_number', label: 'Phone Number' },
  { value: 'abn', label: 'ABN' },
  { value: 'whole_number', label: 'Whole Number' },
  { value: 'decimal_number', label: 'Decimal Number' },
  { value: 'date', label: 'Date' },
  { value: 'time', label: 'Time' },
  { value: 'date_and_time', label: 'Date and Time' },
  { value: 'file', label: 'File' },
  { value: 'selection', label: 'Selection' },
  { value: 'true_or_false', label: 'True or False' },
  { value: 'verification_code', label: 'Verification Code' },
];

export const VAL_CONDITION_TYPE_OPTIONS = [
  { value: 'required_check', label: 'Required Check' },
  { value: 'allowed_value_check', label: 'Allowed Value Check' },
  { value: 'format_check', label: 'Format Check' },
  { value: 'character_limit_check', label: 'Character Limit Check' },
  { value: 'number_range_check', label: 'Number Range Check' },
  { value: 'date_check', label: 'Date Check' },
  { value: 'file_type_check', label: 'File Type Check' },
  { value: 'file_count_check', label: 'File Count Check' },
  { value: 'file_size_check', label: 'File Size Check' },
  { value: 'image_dimensions_check', label: 'Image Dimensions Check' },
  { value: 'duplicate_check', label: 'Duplicate Check' },
  { value: 'relationship_check', label: 'Relationship Check' },
  { value: 'verification_code_check', label: 'Verification Code Check' },
  { value: 'external_check', label: 'External Check' },
];

export const FORMAT_CHECK_OPTIONS = [
  { value: 'letters_only', label: 'Letters Only' },
  { value: 'digits_only', label: 'Digits Only' },
  { value: 'letters_and_spaces', label: 'Letters and Spaces' },
  { value: 'letters_and_digits', label: 'Letters and Digits' },
  { value: 'contains_uppercase_letter', label: 'Contains Uppercase Letter' },
  { value: 'contains_lowercase_letter', label: 'Contains Lowercase Letter' },
  { value: 'contains_digit', label: 'Contains Digit' },
  { value: 'contains_symbol', label: 'Contains Symbol' },
  { value: 'no_whitespace', label: 'No Whitespace' },
];

export const DOMAIN_MODE_OPTIONS = [
  { value: 'any_domain', label: 'Any Domain' },
  { value: 'selected_domains', label: 'Selected Domains' },
];

export const WEB_PROTOCOL_OPTIONS = [
  { value: 'https_only', label: 'HTTPS Only' },
  { value: 'http_only', label: 'HTTP Only' },
  { value: 'both', label: 'Both' },
];

export const YES_NO_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

export const PHONE_INPUT_OPTIONS = [
  { value: 'international', label: 'International' },
  { value: 'national', label: 'National' },
  { value: 'both', label: 'Both' },
];

export const PHONE_COUNTRY_MODE_OPTIONS = [
  { value: 'all_supported_countries', label: 'All Supported Countries' },
  { value: 'selected_countries', label: 'Selected Countries' },
];

export const COUNTRY_OPTIONS = [
  { value: 'AU', label: 'Australia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'US', label: 'United States' },
];

export const ABN_FORMAT_OPTIONS = [
  { value: 'digits_only', label: 'Digits Only' },
  { value: 'allow_spaces', label: 'Allow Spaces' },
];

export const DECIMAL_PRECISION_OPTIONS = [
  { value: 'any', label: 'Any Decimal Precision' },
  { value: 'maximum', label: 'Maximum Decimal Places' },
];

export const DATE_FORMAT_OPTIONS = [
  { value: 'dd/mm/yyyy', label: 'DD/MM/YYYY' },
  { value: 'yyyy-mm-dd', label: 'YYYY-MM-DD' },
];

export const TIME_FORMAT_OPTIONS = [
  { value: 'hh:mm_24', label: 'HH:mm (24-hour)' },
  { value: 'hh:mm_12', label: 'hh:mm a (12-hour)' },
  { value: 'hh:mm:ss_24', label: 'HH:mm:ss (24-hour)' },
];

export const DATETIME_FORMAT_OPTIONS = [
  { value: 'dd/mm/yyyy_hh:mm', label: 'DD/MM/YYYY HH:mm' },
  { value: 'yyyy-mm-dd_hh:mm', label: 'YYYY-MM-DD HH:mm' },
];

export const VERIFICATION_CODE_FORMAT_OPTIONS = [
  { value: 'digits_only', label: 'Digits Only' },
  { value: 'letters_and_digits', label: 'Letters and Digits' },
  { value: 'text', label: 'Text' },
];

export const DATE_COMPARISON_OPTIONS = [
  { value: 'before', label: 'Before' },
  { value: 'on_or_before', label: 'On or Before' },
  { value: 'same_as', label: 'Same As' },
  { value: 'on_or_after', label: 'On or After' },
  { value: 'after', label: 'After' },
];

export const DATE_COMPARE_WITH_OPTIONS = [
  { value: 'current_date_time', label: 'Current Date/Time' },
  { value: 'fixed_date_time', label: 'A Fixed Date/Time' },
  { value: 'another_compatible_field', label: 'Another Compatible Field' },
];

export const DATE_ADJUSTMENT_OPTIONS = [
  { value: 'no_adjustment', label: 'No Adjustment' },
  { value: 'earlier_by', label: 'Earlier By' },
  { value: 'later_by', label: 'Later By' },
];

export const DATE_ADJUST_UNITS = [
  { value: 'days', label: 'Days' },
  { value: 'weeks', label: 'Weeks' },
  { value: 'months', label: 'Months' },
  { value: 'years', label: 'Years' },
];

export const DATETIME_ADJUST_UNITS = [
  { value: 'minutes', label: 'Minutes' },
  { value: 'hours', label: 'Hours' },
  ...DATE_ADJUST_UNITS,
];

export const TIMEZONE_OPTIONS = [
  { value: 'Australia/Sydney', label: 'Australia/Sydney' },
  { value: 'Australia/Melbourne', label: 'Australia/Melbourne' },
  { value: 'Australia/Brisbane', label: 'Australia/Brisbane' },
  { value: 'UTC', label: 'UTC' },
];

export const BOUNDARY_MODE_OPTIONS = [
  { value: 'include', label: 'Include' },
  { value: 'exclude', label: 'Exclude' },
];

export const FILE_SIZE_UNIT_OPTIONS = [
  { value: 'kb', label: 'KB' },
  { value: 'mb', label: 'MB' },
  { value: 'gb', label: 'GB' },
];

export const FILE_SIZE_SCOPE_OPTIONS = [
  { value: 'each_file', label: 'Each File' },
  { value: 'all_files_combined', label: 'All Files Combined' },
];

export const TEXT_MATCH_OPTIONS = [
  { value: 'exact_match', label: 'Exact Match' },
  { value: 'ignore_case', label: 'Ignore Case' },
  { value: 'ignore_surrounding_spaces', label: 'Ignore Surrounding Spaces' },
  { value: 'ignore_case_and_surrounding_spaces', label: 'Ignore Case and Surrounding Spaces' },
];

export const RELATIONSHIP_OPTIONS = [
  { value: 'matches_another_field', label: 'Matches Another Field' },
  { value: 'differs_from_another_field', label: 'Differs From Another Field' },
  { value: 'exists_in_source', label: 'Exists in Source' },
  { value: 'belongs_to_related_record', label: 'Belongs to Related Record' },
];

export const DUPLICATE_SOURCE_OPTIONS = [
  { value: 'customers', label: 'Customers' },
  { value: 'businesses', label: 'Businesses' },
  { value: 'posts', label: 'Posts' },
];

export const DUPLICATE_SCOPE_OPTIONS = [
  { value: 'same_module', label: 'Same Module' },
  { value: 'platform', label: 'Platform' },
];

export const VERIFICATION_SOURCE_OPTIONS = [
  { value: 'email_verification', label: 'Email Verification' },
  { value: 'mobile_verification', label: 'Mobile Verification' },
];

export const EXTERNAL_SERVICE_OPTIONS = [
  { value: 'abr', label: 'Australian Business Register', enabled: true, checks: ['abn_active'], results: ['active', 'cancelled', 'not_found'] },
  { value: 'email_deliverability', label: 'Email Deliverability Service', enabled: true, checks: ['mailbox_exists'], results: ['deliverable', 'undeliverable', 'unknown'] },
];

export const FILE_TYPE_OPTIONS = [
  { value: 'jpeg', label: 'JPEG' },
  { value: 'png', label: 'PNG' },
  { value: 'webp', label: 'WebP' },
  { value: 'pdf', label: 'PDF' },
  { value: 'doc', label: 'Document' },
];

export const VAL_ENTRY_POINTS_BY_MODULE = {
  account_access: ['Login Form'],
  customers: [
    'Customer Signup',
    'Customer Profile Form',
    'Customer Email Verification Form',
    'Customer Mobile Verification Form',
    'Customer Notification Preferences Form',
    'Customer Close Account Form',
  ],
  businesses: [
    'Business Signup',
    'Business Profile Form',
    'Business Email Verification Form',
    'Business Mobile Verification Form',
    'Business Notification Preferences Form',
    'Business Close Account Form',
    'Business Portfolio Form',
  ],
  passwords: ['Forgot Password Form', 'Change Password Form'],
  posts: ['Create Post', 'Edit Post Form'],
  quotes: ['Quote Request Form', 'Quote Reply Form'],
  messages: ['Message Form', 'Message Reply Form'],
  reviews: ['Review Form', 'Review Edit Form', 'Review Reply Form'],
  // Review Flag Form (FORM-000027) is retired — historical ID reserved; Reviews use System Flags only.
  flagging: ['General Flag Form', 'Post Flag Form', 'Message Flag Form', 'Quote Flag Form'],
  support_tickets: ['Contact / Support Form', 'Support Ticket Reply Form'],
  compliance: [
    'Licence Submission Form',
    'Licence Resubmission Form',
    'Badge Submission Form',
    'Badge Resubmission Form',
    'Ticket Submission Form',
    'Ticket Resubmission Form',
  ],
  teams_permissions: ['Add Team Member Form', 'Staff Permission Edit Form', 'Admin Internal Note Form'],
};

export const VAL_TRIGGERS_BY_ENTRY = {
  'Login Form': ['submit'],
  'Customer Signup': ['submit'],
  'Customer Profile Form': ['save'],
  'Customer Email Verification Form': ['submit'],
  'Customer Mobile Verification Form': ['submit'],
  'Customer Notification Preferences Form': ['save'],
  'Customer Close Account Form': ['submit'],
  'Business Signup': ['submit'],
  'Business Profile Form': ['save'],
  'Business Email Verification Form': ['submit'],
  'Business Mobile Verification Form': ['submit'],
  'Business Notification Preferences Form': ['save'],
  'Business Close Account Form': ['submit'],
  'Business Portfolio Form': ['save'],
  'Forgot Password Form': ['submit'],
  'Change Password Form': ['save'],
  'Create Post': ['publish', 'save'],
  'Edit Post Form': ['save', 'publish'],
  'Quote Request Form': ['submit'],
  'Quote Reply Form': ['send'],
  'Message Form': ['send'],
  'Message Reply Form': ['send'],
  'Review Form': ['submit'],
  'Review Edit Form': ['save'],
  'Review Reply Form': ['send'],
  'General Flag Form': ['submit'],
  'Post Flag Form': ['submit'],
  'Message Flag Form': ['submit'],
  'Quote Flag Form': ['submit'],
  'Contact / Support Form': ['submit'],
  'Support Ticket Reply Form': ['send'],
  'Licence Submission Form': ['submit'],
  'Licence Resubmission Form': ['submit'],
  'Badge Submission Form': ['submit'],
  'Badge Resubmission Form': ['submit'],
  'Ticket Submission Form': ['submit'],
  'Ticket Resubmission Form': ['submit'],
  'Add Team Member Form': ['submit'],
  'Staff Permission Edit Form': ['save'],
  'Admin Internal Note Form': ['save'],
};

export const VAL_INPUT_FIELDS_BY_ENTRY = {
  'Login Form': ['Email Address', 'Password'],
  'Customer Signup': ['Email Address', 'Password', 'First Name', 'Last Name', 'Mobile Number', 'Location', 'Profile Image', 'Accept Terms'],
  'Customer Profile Form': ['First Name', 'Last Name', 'Email Address', 'Mobile Number', 'Profile Image', 'Display Name'],
  'Customer Email Verification Form': ['Email Address', 'Verification Code'],
  'Customer Mobile Verification Form': ['Mobile Number', 'Verification Code'],
  'Customer Notification Preferences Form': ['Email Notifications', 'SMS Notifications'],
  'Customer Close Account Form': ['Close Reason', 'Confirm Password'],
  'Business Signup': ['Email Address', 'Business Email', 'Password', 'ABN', 'Business Name', 'Trade Category', 'Featured Services', 'Location', 'Profile Image'],
  'Business Profile Form': ['Business Name', 'Phone Number', 'Email Address', 'Website', 'Description', 'Service Areas', 'Trading Hours'],
  'Business Email Verification Form': ['Email Address', 'Verification Code'],
  'Business Mobile Verification Form': ['Mobile Number', 'Verification Code'],
  'Business Notification Preferences Form': ['Email Notifications', 'SMS Notifications'],
  'Business Close Account Form': ['Close Reason', 'Confirm Password'],
  'Business Portfolio Form': ['Portfolio Title', 'Uploaded Image'],
  'Forgot Password Form': ['Email Address'],
  'Change Password Form': ['Current Password', 'New Password', 'Confirm Password'],
  'Create Post': ['Post Title', 'Post Description', 'Category', 'Subcategory', 'Keyword Selection', 'Location', 'Post Images', 'Uploaded Image'],
  'Edit Post Form': ['Post Title', 'Post Description', 'Category', 'Subcategory', 'Keyword Selection', 'Location', 'Post Images', 'Uploaded Image'],
  'Quote Request Form': ['Job Title', 'Job Description', 'Budget Amount', 'Location', 'Uploaded Attachment'],
  'Quote Reply Form': ['Reply Text', 'Uploaded Attachment'],
  'Message Form': ['Message Text', 'Uploaded Attachment'],
  'Message Reply Form': ['Reply Text', 'Uploaded Attachment'],
  'Review Form': ['Rating', 'Review Text', 'Uploaded Image'],
  'Review Edit Form': ['Rating', 'Review Text', 'Uploaded Image'],
  'Review Reply Form': ['Reply Text'],
  'General Flag Form': ['Flag Reason', 'Flag Summary', 'Uploaded Attachment'],
  'Post Flag Form': ['Flag Reason', 'Flag Summary', 'Uploaded Attachment'],
  'Message Flag Form': ['Flag Reason', 'Flag Summary', 'Uploaded Attachment'],
  'Quote Flag Form': ['Flag Reason', 'Flag Summary', 'Uploaded Attachment'],
  'Contact / Support Form': ['Name', 'Email Address', 'Subject', 'Message Text', 'Uploaded Attachment'],
  'Support Ticket Reply Form': ['Reply Text', 'Uploaded Attachment'],
  'Licence Submission Form': ['Holder Name', 'Licence Number', 'Issuing Authority', 'Issue Date', 'Expiry Date', 'Evidence'],
  'Licence Resubmission Form': ['Holder Name', 'Licence Number', 'Issue Date', 'Expiry Date', 'Evidence'],
  'Badge Submission Form': ['Holder Name', 'Certificate / Reference Number', 'Issue Date', 'Expiry Date', 'Evidence'],
  'Badge Resubmission Form': ['Holder Name', 'Certificate / Reference Number', 'Evidence'],
  'Ticket Submission Form': ['Holder Name', 'Ticket / Certificate / Reference Number', 'Issue Date', 'Expiry Date', 'Evidence'],
  'Ticket Resubmission Form': ['Holder Name', 'Ticket / Certificate / Reference Number', 'Evidence'],
  'Add Team Member Form': ['Email Address', 'First Name', 'Last Name', 'Role'],
  'Staff Permission Edit Form': ['Role', 'Permissions'],
  'Admin Internal Note Form': ['Note Text'],
};

const LEGACY_ENTRY_POINT_MAP = {
  'Customer Signup Form': 'Customer Signup',
  'Business Signup Form': 'Business Signup',
  'Create Post Form': 'Create Post',
  'Customer Login Form': 'Login Form',
  'Business Login Form': 'Login Form',
  'Post Creation Form': 'Create Post',
  'Post Edit Form': 'Edit Post Form',
};

const LEGACY_MODULE_MAP = {
  documents: 'compliance',
  flag: 'flagging',
  contact: 'support_tickets',
  business: 'businesses',
  customer: 'customers',
};

const FIELD_TYPE_BY_LABEL = {
  'Email Address': 'email',
  'Business Email': 'email',
  'Website': 'web',
  'Phone Number': 'phone',
  'Mobile Number': 'phone',
  ABN: 'abn',
  'Budget Amount': 'decimal',
  Rating: 'whole_number',
  'Issue Date': 'date',
  'Expiry Date': 'date',
  'Post Images': 'file',
  'Uploaded Image': 'file',
  'Uploaded Attachment': 'file',
  'Profile Image': 'file',
  Evidence: 'file',
  'Accept Terms': 'boolean',
  'Email Notifications': 'boolean',
  'SMS Notifications': 'boolean',
  'Verification Code': 'verification_code',
  'Trade Category': 'selection',
  Category: 'selection',
  Subcategory: 'selection',
  Role: 'selection',
  'Flag Reason': 'selection',
};

function inferFieldType(label) {
  if (FIELD_TYPE_BY_LABEL[label]) return FIELD_TYPE_BY_LABEL[label];
  if (/email/i.test(label)) return 'email';
  if (/phone|mobile/i.test(label)) return 'phone';
  if (/website|url/i.test(label)) return 'web';
  if (/image|attachment|evidence|file|upload/i.test(label)) return 'file';
  if (/date/i.test(label)) return 'date';
  if (/amount|number|count/i.test(label)) return 'decimal';
  if (/password|code/i.test(label)) return 'text';
  if (/accept|notification/i.test(label)) return 'boolean';
  if (/category|role|reason|selection/i.test(label)) return 'selection';
  return 'text';
}

const BASE_CHECKS_BY_TYPE = {
  text: ['text'],
  email: ['email_address'],
  web: ['web_address'],
  phone: ['phone_number'],
  abn: ['abn'],
  whole_number: ['whole_number'],
  decimal: ['decimal_number'],
  date: ['date'],
  time: ['time'],
  datetime: ['date_and_time'],
  file: ['file'],
  selection: ['selection'],
  boolean: ['true_or_false'],
  verification_code: ['verification_code'],
};

const CONDITIONS_BY_TYPE = {
  text: ['required_check', 'allowed_value_check', 'format_check', 'character_limit_check', 'duplicate_check', 'relationship_check'],
  email: ['required_check', 'allowed_value_check', 'duplicate_check', 'external_check'],
  web: ['required_check', 'duplicate_check'],
  phone: ['required_check', 'duplicate_check'],
  abn: ['required_check', 'duplicate_check', 'external_check'],
  whole_number: ['required_check', 'number_range_check', 'allowed_value_check'],
  decimal: ['required_check', 'number_range_check'],
  date: ['required_check', 'date_check'],
  time: ['required_check', 'date_check'],
  datetime: ['required_check', 'date_check'],
  file: ['required_check', 'file_type_check', 'file_count_check', 'file_size_check', 'image_dimensions_check'],
  selection: ['required_check', 'allowed_value_check'],
  boolean: ['required_check', 'allowed_value_check'],
  verification_code: ['required_check', 'format_check', 'character_limit_check', 'verification_code_check'],
};

export function labelFromOptions(options, value) {
  if (value == null || value === '') return '';
  return options.find((option) => option.value === value)?.label ?? String(value);
}

export function getValidationModuleLabel(value) {
  return labelFromOptions(VAL_MODULE_OPTIONS, value) || value || '—';
}

export function getTriggerLabel(value) {
  return labelFromOptions(VAL_TRIGGER_OPTIONS, value) || value || '—';
}

export function getBaseCheckLabel(value) {
  return labelFromOptions(VAL_BASE_CHECK_OPTIONS, value) || value || '—';
}

export function getConditionTypeLabel(value) {
  return labelFromOptions(VAL_CONDITION_TYPE_OPTIONS, value) || value || '—';
}

export function normalizeValidationEntryPoint(value) {
  if (!value) return '';
  return LEGACY_ENTRY_POINT_MAP[value] || value;
}

export function normalizeValidationModule(value) {
  if (!value) return '';
  return LEGACY_MODULE_MAP[value] || value;
}

export function normalizeValidationRuleScope(module, entryPoint) {
  const ep = normalizeValidationEntryPoint(entryPoint);
  let mod = normalizeValidationModule(module);
  if (ep === 'Login Form' && (mod === 'customers' || mod === 'businesses')) mod = 'account_access';
  if (ep === 'Change Password Form' && (mod === 'customers' || mod === 'businesses')) mod = 'passwords';
  if (ep === 'Contact / Support Form' && ['customers', 'businesses', 'contact'].includes(mod)) mod = 'support_tickets';
  return { module: mod, entryPoint: ep };
}

export function getEntryPointsForModule(module) {
  const mod = normalizeValidationModule(module);
  return (VAL_ENTRY_POINTS_BY_MODULE[mod] || []).map((label) => ({ value: label, label }));
}

export function getTriggersForEntry(entryPoint) {
  const ep = normalizeValidationEntryPoint(entryPoint);
  const values = VAL_TRIGGERS_BY_ENTRY[ep] || ['submit'];
  return VAL_TRIGGER_OPTIONS.filter((option) => values.includes(option.value));
}

export function getInputFieldsForEntry(entryPoint) {
  const ep = normalizeValidationEntryPoint(entryPoint);
  return (VAL_INPUT_FIELDS_BY_ENTRY[ep] || []).map((label) => ({ value: label, label }));
}

export function getFieldType(fieldLabel) {
  return inferFieldType(fieldLabel);
}

export function getFieldDefinition(entryPoint, fieldLabel) {
  const type = getFieldType(fieldLabel);
  const image = /image/i.test(fieldLabel || '');
  const multiple = /images|attachment/i.test(fieldLabel || '');
  return {
    label: fieldLabel,
    type,
    reference: `${normalizeValidationEntryPoint(entryPoint)}::${fieldLabel}`,
    multiple,
    image,
    fileTypes: type === 'file' ? (image ? ['jpeg', 'png', 'webp'] : ['jpeg', 'png', 'webp', 'pdf', 'doc']) : [],
    dateFormats: DATE_FORMAT_OPTIONS,
    timeFormats: TIME_FORMAT_OPTIONS,
    dateTimeFormats: DATETIME_FORMAT_OPTIONS,
    choices: type === 'selection' || type === 'boolean' ? (type === 'boolean' ? ['True', 'False'] : ['Option A', 'Option B', 'Option C']) : [],
    relatedFields: getInputFieldsForEntry(entryPoint).map((field) => field.value).filter((label) => label !== fieldLabel),
    available: true,
  };
}

export function getBaseChecksForField(fieldLabel) {
  const type = getFieldType(fieldLabel);
  const keys = BASE_CHECKS_BY_TYPE[type] || ['text'];
  return VAL_BASE_CHECK_OPTIONS.filter((option) => keys.includes(option.value));
}

export function getConditionTypesForField(fieldLabel, baseCheck) {
  const type = getFieldType(fieldLabel);
  let keys = [...(CONDITIONS_BY_TYPE[type] || ['required_check'])];
  if (type === 'file' && !/image/i.test(fieldLabel || '')) {
    keys = keys.filter((key) => key !== 'image_dimensions_check');
  }
  if (baseCheck === 'whole_number' || baseCheck === 'decimal_number') {
    if (!keys.includes('number_range_check')) keys.push('number_range_check');
  }
  return VAL_CONDITION_TYPE_OPTIONS.filter((option) => keys.includes(option.value));
}

export function namesMatch(a, b) {
  return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
}

export function nextValidationRuleId(rules) {
  const nums = (rules || []).map((rule) => {
    const match = String(rule.id || '').match(/^VAL-(\d+)$/i);
    return match ? parseInt(match[1], 10) : 0;
  });
  const max = nums.length ? Math.max(...nums) : 0;
  return `VAL-${String(max + 1).padStart(4, '0')}`;
}

export function emptyBaseCheckSettings() {
  return {
    domainMode: 'any_domain',
    domains: [],
    allowSubdomains: 'no',
    webProtocol: 'https_only',
    phoneInput: 'both',
    phoneCountryMode: 'all_supported_countries',
    countries: [],
    countryField: '',
    abnFormat: 'digits_only',
    decimalPrecision: 'any',
    maxDecimalPlaces: '',
    dateFormat: 'dd/mm/yyyy',
    timeFormat: 'hh:mm_24',
    dateTimeFormat: 'dd/mm/yyyy_hh:mm',
    verificationCodeFormat: 'digits_only',
  };
}

export function emptyConditionSettings(type) {
  return {
    formatOption: '',
    minChars: '',
    maxChars: '',
    minNum: '',
    maxNum: '',
    minInclude: 'include',
    maxInclude: 'include',
    comparison: '',
    compareWith: '',
    fixedDateTime: '',
    compareField: '',
    adjustment: 'no_adjustment',
    adjustAmount: '',
    adjustUnit: '',
    timeZone: 'Australia/Sydney',
    fileTypes: [],
    minFiles: '',
    maxFiles: '',
    minSize: '',
    maxSize: '',
    sizeUnit: 'mb',
    sizeScope: 'each_file',
    minWidth: '',
    maxWidth: '',
    minHeight: '',
    maxHeight: '',
    aspectRatios: '',
    allowedValues: [],
    allowedSource: '',
    allowedField: '',
    duplicateSource: '',
    duplicateScope: '',
    duplicateField: '',
    matchOption: 'exact_match',
    relationship: '',
    relatedField: '',
    relatedSource: '',
    verificationSource: '',
    verificationCodeField: '',
    externalService: '',
    externalCheck: '',
    acceptedResults: [],
  };
}

export function createEmptyValidationForm() {
  return {
    id: '',
    ruleName: '',
    module: '',
    entryPoint: '',
    trigger: '',
    inputField: '',
    baseCheck: '',
    baseCheckSettings: emptyBaseCheckSettings(),
    baseCheckMessage: '',
    conditions: [],
    changeReason: '',
    dateAdded: '',
    addedBy: '',
    lastUpdated: '',
    lastUpdatedBy: '',
  };
}

export function createEmptyCondition() {
  return {
    id: `cond-${Date.now()}`,
    name: '',
    type: '',
    settings: emptyConditionSettings(''),
    message: '',
  };
}

export function normalizeValidationForm(raw) {
  if (!raw) return createEmptyValidationForm();
  const scope = normalizeValidationRuleScope(raw.module, raw.entryPoint);
  const trigger = raw.trigger || raw.formAction || '';
  const baseCheck = raw.baseCheck || (
    raw.ruleType === 'required_field' ? '' : raw.ruleType === 'format_check' && raw.inputField === 'ABN' ? 'abn' : ''
  );
  return {
    ...createEmptyValidationForm(),
    ...raw,
    module: scope.module,
    entryPoint: scope.entryPoint,
    trigger,
    inputField: raw.inputField || raw.field || '',
    baseCheck: baseCheck || raw.baseCheck || '',
    baseCheckSettings: { ...emptyBaseCheckSettings(), ...(raw.baseCheckSettings || {}) },
    baseCheckMessage: raw.baseCheckMessage || raw.validationMessage || '',
    conditions: Array.isArray(raw.conditions) ? raw.conditions : [],
    changeReason: raw.changeReason || '',
    dateAdded: raw.dateAdded || raw.createdOn || '',
    addedBy: raw.addedBy || raw.createdBy || '',
    lastUpdated: raw.lastUpdated || raw.modifiedOn || '',
    lastUpdatedBy: raw.lastUpdatedBy || raw.modifiedBy || '',
  };
}

export function formatValidationDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = date.getDate();
  const month = date.toLocaleString('en-GB', { month: 'short' });
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const suffix = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;
  return `${day} ${month} ${year}, ${hours}:${minutes} ${suffix}`;
}

export function formatConditionsPreview(conditions = []) {
  if (!conditions.length) return { text: 'No Conditions', extraCount: 0, lines: [], typesText: '—' };
  const names = conditions.map((condition) => condition.name || getConditionTypeLabel(condition.type));
  const types = [...new Set(conditions.map((condition) => getConditionTypeLabel(condition.type)).filter(Boolean))];
  if (names.length === 1) return { text: names[0], extraCount: 0, lines: names, typesText: types.join(' · ') };
  return {
    text: `${names[0]} · +${names.length - 1} more`,
    extraCount: names.length - 1,
    lines: names,
    typesText: types.join(' · '),
  };
}

export function formatConditionSettings(condition) {
  const settings = condition.settings || {};
  const type = condition.type;
  if (type === 'required_check') return 'None';
  if (type === 'format_check') return labelFromOptions(FORMAT_CHECK_OPTIONS, settings.formatOption) || '—';
  if (type === 'character_limit_check') {
    const bits = [];
    if (settings.minChars !== '') bits.push(`Minimum ${settings.minChars}`);
    if (settings.maxChars !== '') bits.push(`Maximum ${settings.maxChars}`);
    return bits.join(' / ') || '—';
  }
  if (type === 'file_type_check') return (settings.fileTypes || []).map((value) => labelFromOptions(FILE_TYPE_OPTIONS, value)).join(', ') || '—';
  if (type === 'file_count_check') {
    const bits = [];
    if (settings.minFiles !== '') bits.push(`Minimum ${settings.minFiles}`);
    if (settings.maxFiles !== '') bits.push(`Maximum ${settings.maxFiles}`);
    return bits.join(' / ') || '—';
  }
  if (type === 'file_size_check') {
    const bits = [];
    if (settings.minSize !== '') bits.push(`Minimum ${settings.minSize} ${String(settings.sizeUnit || '').toUpperCase()}`);
    if (settings.maxSize !== '') bits.push(`Maximum ${settings.maxSize} ${String(settings.sizeUnit || '').toUpperCase()}`);
    if (settings.sizeScope) bits.push(labelFromOptions(FILE_SIZE_SCOPE_OPTIONS, settings.sizeScope));
    return bits.join(' · ') || '—';
  }
  if (type === 'number_range_check') {
    const bits = [];
    if (settings.minNum !== '') bits.push(`Minimum ${settings.minNum} (${settings.minInclude})`);
    if (settings.maxNum !== '') bits.push(`Maximum ${settings.maxNum} (${settings.maxInclude})`);
    return bits.join(' / ') || '—';
  }
  if (type === 'allowed_value_check') return (settings.allowedValues || []).join(', ') || '—';
  if (type === 'date_check') return [labelFromOptions(DATE_COMPARISON_OPTIONS, settings.comparison), labelFromOptions(DATE_COMPARE_WITH_OPTIONS, settings.compareWith)].filter(Boolean).join(' · ') || '—';
  if (type === 'duplicate_check') return [labelFromOptions(DUPLICATE_SOURCE_OPTIONS, settings.duplicateSource), labelFromOptions(TEXT_MATCH_OPTIONS, settings.matchOption)].filter(Boolean).join(' · ') || '—';
  if (type === 'relationship_check') return labelFromOptions(RELATIONSHIP_OPTIONS, settings.relationship) || '—';
  if (type === 'verification_code_check') return labelFromOptions(VERIFICATION_SOURCE_OPTIONS, settings.verificationSource) || '—';
  if (type === 'external_check') return [labelFromOptions(EXTERNAL_SERVICE_OPTIONS, settings.externalService), ...(settings.acceptedResults || [])].filter(Boolean).join(' · ') || '—';
  if (type === 'image_dimensions_check') {
    const bits = [];
    if (settings.minWidth) bits.push(`Min W ${settings.minWidth}`);
    if (settings.maxWidth) bits.push(`Max W ${settings.maxWidth}`);
    if (settings.minHeight) bits.push(`Min H ${settings.minHeight}`);
    if (settings.maxHeight) bits.push(`Max H ${settings.maxHeight}`);
    if (settings.aspectRatios) bits.push(`Ratio ${settings.aspectRatios}`);
    return bits.join(' · ') || '—';
  }
  return '—';
}

export function formatBaseCheckSettings(rule) {
  const settings = rule.baseCheckSettings || {};
  switch (rule.baseCheck) {
    case 'email_address':
      return settings.domainMode === 'selected_domains'
        ? `Selected Domains · ${(settings.domains || []).join(', ')} · Allow Subdomains ${labelFromOptions(YES_NO_OPTIONS, settings.allowSubdomains)}`
        : 'Any Domain';
    case 'web_address':
      return `${labelFromOptions(WEB_PROTOCOL_OPTIONS, settings.webProtocol)} · ${settings.domainMode === 'selected_domains' ? 'Selected Domains' : 'Any Domain'}`;
    case 'phone_number':
      return `${labelFromOptions(PHONE_INPUT_OPTIONS, settings.phoneInput)} · ${labelFromOptions(PHONE_COUNTRY_MODE_OPTIONS, settings.phoneCountryMode)}`;
    case 'abn':
      return labelFromOptions(ABN_FORMAT_OPTIONS, settings.abnFormat);
    case 'decimal_number':
      return settings.decimalPrecision === 'maximum' ? `Maximum ${settings.maxDecimalPlaces} decimal places` : 'Any Decimal Precision';
    case 'date':
      return labelFromOptions(DATE_FORMAT_OPTIONS, settings.dateFormat);
    case 'time':
      return labelFromOptions(TIME_FORMAT_OPTIONS, settings.timeFormat);
    case 'date_and_time':
      return labelFromOptions(DATETIME_FORMAT_OPTIONS, settings.dateTimeFormat);
    case 'verification_code':
      return labelFromOptions(VERIFICATION_CODE_FORMAT_OPTIONS, settings.verificationCodeFormat);
    default:
      return 'None';
  }
}

export function sortValidationRules(rules = []) {
  return [...rules].sort((a, b) => {
    const aTime = new Date(a.lastUpdated || a.dateAdded || 0).getTime();
    const bTime = new Date(b.lastUpdated || b.dateAdded || 0).getTime();
    return bTime - aTime;
  });
}

function actorFields(stamp) {
  return {
    addedBy: 'Olivia Brown',
    lastUpdatedBy: 'Olivia Brown',
    dateAdded: stamp,
    lastUpdated: stamp,
  };
}

export function buildSampleValidationRules() {
  const required = (name, message) => ({
    id: `cond-${name}`,
    name,
    type: 'required_check',
    settings: emptyConditionSettings('required_check'),
    message,
  });

  return [
    {
      id: 'VAL-0001',
      ruleName: 'Business ABN Validation',
      module: 'businesses',
      entryPoint: 'Business Signup',
      trigger: 'submit',
      inputField: 'ABN',
      baseCheck: 'abn',
      baseCheckSettings: { ...emptyBaseCheckSettings(), abnFormat: 'digits_only' },
      baseCheckMessage: 'Enter a valid Australian Business Number.',
      conditions: [required('Required Check', 'Enter the ABN for this business.')],
      changeReason: 'Added ABN validation for business signup.',
      ...actorFields('2026-08-10T09:00:00+10:00'),
    },
    {
      id: 'VAL-0002',
      ruleName: 'Business Email Validation',
      module: 'businesses',
      entryPoint: 'Business Signup',
      trigger: 'submit',
      inputField: 'Business Email',
      baseCheck: 'email_address',
      baseCheckSettings: { ...emptyBaseCheckSettings(), domainMode: 'any_domain' },
      baseCheckMessage: 'Enter a valid email address.',
      conditions: [required('Required Check', 'Enter your business email address.')],
      changeReason: 'Updated the business email validation messages.',
      ...actorFields('2026-08-10T09:20:00+10:00'),
    },
    {
      id: 'VAL-0003',
      ruleName: 'Customer Mobile Validation',
      module: 'customers',
      entryPoint: 'Customer Signup',
      trigger: 'submit',
      inputField: 'Mobile Number',
      baseCheck: 'phone_number',
      baseCheckSettings: {
        ...emptyBaseCheckSettings(),
        phoneInput: 'both',
        phoneCountryMode: 'all_supported_countries',
      },
      baseCheckMessage: 'Enter a valid mobile number.',
      conditions: [required('Required Check', 'Enter your mobile number.')],
      changeReason: 'Added mobile validation for customer signup.',
      ...actorFields('2026-08-10T09:40:00+10:00'),
    },
    {
      id: 'VAL-0004',
      ruleName: 'Post Image Validation',
      module: 'posts',
      entryPoint: 'Create Post',
      trigger: 'publish',
      inputField: 'Post Images',
      baseCheck: 'file',
      baseCheckSettings: emptyBaseCheckSettings(),
      baseCheckMessage: 'Upload a valid image file.',
      conditions: [
        {
          id: 'cond-file-type',
          name: 'File Type Check',
          type: 'file_type_check',
          settings: { ...emptyConditionSettings('file_type_check'), fileTypes: ['jpeg', 'png'] },
          message: 'Use a JPEG or PNG image.',
        },
        {
          id: 'cond-file-count',
          name: 'File Count Check',
          type: 'file_count_check',
          settings: { ...emptyConditionSettings('file_count_check'), minFiles: '1', maxFiles: '8' },
          message: 'Upload between 1 and 8 images.',
        },
        {
          id: 'cond-file-size',
          name: 'File Size Check',
          type: 'file_size_check',
          settings: { ...emptyConditionSettings('file_size_check'), maxSize: '10', sizeUnit: 'mb', sizeScope: 'each_file' },
          message: 'Each image must be 10 MB or smaller.',
        },
      ],
      changeReason: 'Added image file checks for post publishing.',
      ...actorFields('2026-08-10T10:05:00+10:00'),
    },
    {
      id: 'VAL-0005',
      ruleName: 'Post Title Validation',
      module: 'posts',
      entryPoint: 'Create Post',
      trigger: 'publish',
      inputField: 'Post Title',
      baseCheck: 'text',
      baseCheckSettings: emptyBaseCheckSettings(),
      baseCheckMessage: 'Enter a valid post title.',
      conditions: [],
      changeReason: 'Added post title format checking.',
      ...actorFields('2026-08-10T10:25:00+10:00'),
    },
  ].map(normalizeValidationForm);
}

export function findDuplicateValidationRule(rules, candidate, excludeId) {
  const scope = normalizeValidationRuleScope(candidate.module, candidate.entryPoint);
  const trigger = candidate.trigger || candidate.formAction;
  return (rules || []).find(
    (rule) =>
      rule.id !== excludeId &&
      normalizeValidationModule(rule.module) === scope.module &&
      normalizeValidationEntryPoint(rule.entryPoint) === scope.entryPoint &&
      (rule.trigger || rule.formAction) === trigger &&
      (rule.inputField || rule.field) === candidate.inputField,
  );
}

/** @deprecated compatibility aliases */
export const VAL_FORM_ACTION_OPTIONS = VAL_TRIGGER_OPTIONS;
export const VAL_RULE_TYPE_OPTIONS = VAL_BASE_CHECK_OPTIONS;
export const VAL_RULE_RESULT_OPTIONS = [
  { value: 'stop_submission', label: 'Stop Submission' },
  { value: 'stop_save', label: 'Stop Save' },
  { value: 'stop_send', label: 'Stop Send' },
];
export const VAL_FORM_ACTIONS_BY_ENTRY = VAL_TRIGGERS_BY_ENTRY;
export const VAL_RULE_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
];
export function getFormActionsForEntry(entryPoint) {
  return getTriggersForEntry(entryPoint);
}
export function normalizeValidationFormAction(value, entryPoint) {
  const allowed = getTriggersForEntry(entryPoint).map((option) => option.value);
  if (allowed.includes(value)) return value;
  return allowed[0] || 'submit';
}
export function labelFormAction(value) {
  return getTriggerLabel(value);
}
export function getBlockingRuleResultForFormAction() {
  return 'stop_submission';
}
export function getRuleTypesForField(_entryPoint, fieldLabel) {
  return getBaseChecksForField(fieldLabel);
}
export function getAllowedRuleResultsForType() {
  return ['stop_submission'];
}
export function normalizeValidationStatus() {
  return 'active';
}
export function formatRuleValueDisplay(baseCheck, settings) {
  return formatBaseCheckSettings({ baseCheck, baseCheckSettings: settings });
}
export function isRuleValueRequired() {
  return false;
}
export function mapRuleResultValueToLabel() {
  return '—';
}
export function mapRuleResultLabelToValue() {
  return '';
}
export function mapRuleTypeLabelToValue(label) {
  return VAL_BASE_CHECK_OPTIONS.find((option) => option.label === label)?.value || '';
}
